// This file is auto-generated by @hey-api/openapi-ts

import type { GetUserPlaylistsApiV1PlaylistsGetResponse, GetPublicPlaylistsApiV1PlaylistsPublicGetResponse, GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponse, GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponse, GetNbaGamesApiV1NbaGamesGetResponse, GetNbaScheduleGamesApiV1NbaGamesScheduleGetResponse, GetNbaGamePbpApiV1NbaGamesGameIdPbpGetResponse, GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponse, GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponse, GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponse, GetWnbaGamesApiV1WnbaGamesGetResponse, GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponse, GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponse, GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponse } from './types.gen';

const playlistVideoSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    data.addedAt = new Date(data.addedAt);
    return data;
};

const playlistSchemaResponseTransformer = (data: any) => {
    data.createdAt = new Date(data.createdAt);
    data.updatedAt = new Date(data.updatedAt);
    data.videos = data.videos.map((item: any) => {
        return playlistVideoSchemaResponseTransformer(item);
    });
    return data;
};

export const getUserPlaylistsApiV1PlaylistsGetResponseTransformer = async (data: any): Promise<GetUserPlaylistsApiV1PlaylistsGetResponse> => {
    data = data.map((item: any) => {
        return playlistSchemaResponseTransformer(item);
    });
    return data;
};

export const getPublicPlaylistsApiV1PlaylistsPublicGetResponseTransformer = async (data: any): Promise<GetPublicPlaylistsApiV1PlaylistsPublicGetResponse> => {
    data = data.map((item: any) => {
        return playlistSchemaResponseTransformer(item);
    });
    return data;
};

const videoEventSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

const paginationResponseListVideoEventSchemaResponseTransformer = (data: any) => {
    data.items = data.items.map((item: any) => {
        return videoEventSchemaResponseTransformer(item);
    });
    return data;
};

export const getNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponseTransformer = async (data: any): Promise<GetNbaPlayersPbpApiV1NbaPlayersPlayerIdPbpGetResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponseTransformer = async (data: any): Promise<GetNbaPlayersPbpBatchApiV1NbaPlayersPbpBatchPostResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

const gameSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

export const getNbaGamesApiV1NbaGamesGetResponseTransformer = async (data: any): Promise<GetNbaGamesApiV1NbaGamesGetResponse> => {
    data = data.map((item: any) => {
        return gameSchemaResponseTransformer(item);
    });
    return data;
};

const scheduleGameSchemaResponseTransformer = (data: any) => {
    data.date = new Date(data.date);
    return data;
};

export const getNbaScheduleGamesApiV1NbaGamesScheduleGetResponseTransformer = async (data: any): Promise<GetNbaScheduleGamesApiV1NbaGamesScheduleGetResponse> => {
    data = data.map((item: any) => {
        return scheduleGameSchemaResponseTransformer(item);
    });
    return data;
};

export const getNbaGamePbpApiV1NbaGamesGameIdPbpGetResponseTransformer = async (data: any): Promise<GetNbaGamePbpApiV1NbaGamesGameIdPbpGetResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponseTransformer = async (data: any): Promise<GetNbaGamesPbpBatchApiV1NbaGamesPbpBatchPostResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponseTransformer = async (data: any): Promise<GetWnbaPlayersPbpApiV1WnbaPlayersPlayerIdPbpGetResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponseTransformer = async (data: any): Promise<GetWnbaPlayersPbpBatchApiV1WnbaPlayersPbpBatchPostResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getWnbaGamesApiV1WnbaGamesGetResponseTransformer = async (data: any): Promise<GetWnbaGamesApiV1WnbaGamesGetResponse> => {
    data = data.map((item: any) => {
        return gameSchemaResponseTransformer(item);
    });
    return data;
};

export const getWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponseTransformer = async (data: any): Promise<GetWnbaScheduleGamesApiV1WnbaGamesScheduleGetResponse> => {
    data = data.map((item: any) => {
        return scheduleGameSchemaResponseTransformer(item);
    });
    return data;
};

export const getWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponseTransformer = async (data: any): Promise<GetWnbaGamePbpApiV1WnbaGamesGameIdPbpGetResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};

export const getWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponseTransformer = async (data: any): Promise<GetWnbaGamesPbpBatchApiV1WnbaGamesPbpBatchPostResponse> => {
    data = paginationResponseListVideoEventSchemaResponseTransformer(data);
    return data;
};